import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export var isChildType = function isChildType(child, type) {
  return child instanceof Object && 'type' in child && child.type === type;
};
export var isChildOneOfType = function isChildOneOfType(child, types) {
  return !!types.find(function (type) {
    return isChildType(child, type);
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var findChildOfType = function findChildOfType(children, type) {
  return React.Children.toArray(children).find(function (child) {
    return isChildType(child, type);
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var findChildrenOfType = function findChildrenOfType(children, types) {
  return React.Children.toArray(children).filter(function (child) {
    return types.some(function (type) {
      return isChildType(child, type);
    });
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var findChildrenOfTypeRecursively = function findChildrenOfTypeRecursively(children, types) {
  var result = [];
  var findChildren = function findChildren(child) {
    if (Array.isArray(child)) {
      child.forEach(findChildren);
    } else if ( /*#__PURE__*/React.isValidElement(child)) {
      if (types.some(function (type) {
        return isChildType(child, type);
      })) {
        result.push(child);
      }
      findChildren(child.props.children);
    }
  };
  findChildren(children);
  return result;
};
export function hasSymbol(child, symbol) {
  var _child$type;
  return child instanceof Object && 'type' in child &&
  // @ts-expect-error Allow access of arbitrary symbol names
  (child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type[symbol]) === true;
}